import { PageMeta } from "@/components/PageMeta";
import { CtaLink } from "@/components/Button";
import { notFoundSeo } from "@/content/seo";

export function NotFoundPage() {
  return (
    <>
      <PageMeta title={notFoundSeo.title} description={notFoundSeo.description} path="/404" />
      <section className="container section not-found">
        <p className="eyebrow">404</p>
        <h1>This page doesn&rsquo;t exist</h1>
        <p>
          The page you were looking for isn&rsquo;t part of the Devory website. It may have moved,
          or the link may be out of date.
        </p>
        <div className="not-found-actions">
          <CtaLink to="/" variant="primary">
            Go to homepage
          </CtaLink>
          <CtaLink to="/contact" variant="secondary">
            Contact Devory
          </CtaLink>
        </div>
      </section>
    </>
  );
}
